import { Button } from '../../common/Button/Button';
import styles from './BottomAppBar.module.css';

export interface BottomAppBarItem {
  icon: React.ReactNode;
  label?: string;
  onClick: () => void;
}

interface BottomAppBarProps {
  items: BottomAppBarItem[];
}

export function BottomAppBar({
  items,
}: BottomAppBarProps) {
  return (
    <footer className={styles.bottomBar}>
      {items.map((item, index) => (
        <Button
          key={index}
          className={styles.button}
          onClick={item.onClick}
        >
          {item.icon}
          {item.label && (
            <span>{item.label}</span>
          )}
        </Button>
      ))}
    </footer>
  );
}